export default class Company {
    constructor({
        id = 0,
        statusId = 0,
        name = '',
        address= '',
        statusRel = null,
        createdAt = new Date(),
        updatedAt= new Date()
    } = {}) {
        this.id = id;
        this.statusId = statusId;
        this.name = name;
        this.address = address;
        this.statusRel = statusRel;
        this.createdAt = createdAt;
        this.updatedAt = updatedAt;
    }
}